/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import { RECEIVED_ASSET_ALLOCATION } from 'state/assetAllocation/AssetAllocationActions';

export const assetAllocationInitialState = {};

export const assetAllocationReducer = (
  state = assetAllocationInitialState,
  action
) => {
  if (action.type === RECEIVED_ASSET_ALLOCATION) {
    return action.assetAllocation;
  }
  return state;
};
